module.exports = __webpack_public_path__ + "media/theme/sample__itunes-805bbac7.png";